import React from 'react';

interface AppLogoProps {
  size?: number;
  className?: string;
  onClick?: () => void;
}

export default function AppLogo({ size = 64, className = '', onClick }: AppLogoProps) {
  return (
    <div
      className={`flex-shrink-0 ${className}`}
      style={{ width: size, height: size, cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      aria-label="Surfsterre logo"
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Board deck — elongated hexagonal */}
        <defs>
          <linearGradient id="deckGrad" x1="0" y1="64" x2="64" y2="0" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#0077ff" />
            <stop offset="100%" stopColor="#00e5ff" />
          </linearGradient>
          <filter id="deckGlow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>
        {/* Deck shape */}
        <path
          d="M8 38 L10 22 L28 12 L54 18 L56 34 L38 52 L12 46 Z"
          fill="url(#deckGrad)"
          filter="url(#deckGlow)"
        />
        {/* Grip tape lines */}
        <path d="M16 28 L44 22" stroke="rgba(0,119,255,0.6)" strokeWidth="1" />
        <path d="M14 34 L42 28" stroke="rgba(0,119,255,0.6)" strokeWidth="1" />
        <path d="M16 40 L40 34" stroke="rgba(0,119,255,0.6)" strokeWidth="1" />
        {/* Wheels */}
        <circle cx="18" cy="44" r="5" fill="#ff4d6d" />
        <circle cx="18" cy="44" r="2.5" fill="#0d0d0f" />
        <circle cx="46" cy="24" r="5" fill="#ff4d6d" />
        <circle cx="46" cy="24" r="2.5" fill="#0d0d0f" />
        {/* Motion streak */}
        <path d="M6 32 L-2 30" stroke="rgba(255,255,255,0.25)" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8 38 L0 37" stroke="rgba(255,255,255,0.15)" strokeWidth="1" strokeLinecap="round" />
        <path d="M10 44 L4 44" stroke="rgba(255,255,255,0.1)" strokeWidth="1" strokeLinecap="round" />
      </svg>
    </div>
  );
}